import { API, authClient } from '../index';

// Get all plan customers
export const getAllPlanCustomer = () => {
    return authClient().get(`${API}/planCustomer/`)
}

// Get plan customers by id
export const getPlanCustomerById = (id) => {
    return authClient().get(`${API}/planCustomer/${id}`)
}

// Get plan customers by id
export const getPlanCustomerByCustomer = (customerId) => {
    return authClient().get(`${API}/planCustomer/customer/${customerId}`)
}

// Create plan customers
export const postPlanCustomer = async (planCustomer) => {
    return authClient().post(`${API}/planCustomer/`, planCustomer)
}

